import { StandardEvents } from '@shopify/events';

let operation = 0;
document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  const current = ++operation;
  event.promise?.then(({cart, detail}) => {
    if (current !== operation) return;
    // The shared transaction owns the settled count; provider events can carry
    // an earlier snapshot while reward removal/addition is still in flight.
    if (window.TeaDucksCartSafety) return;
    const count = Number(cart?.totalQuantity ?? detail?.itemCount);
    if (!Number.isSafeInteger(count) || count < 0) return;
    for (const output of document.querySelectorAll('[data-cart-count]')) {
      output.textContent = `(${count})`;
      output.hidden = count === 0;
      const label = output.dataset.cartCountLabel;
      if (label) output.setAttribute('aria-label', label.replace('__count__', String(count)));
    }
  }).catch((error) => {
    if (error?.name !== 'AbortError') console.warn('[Tea Ducks] Cart count update failed.', error);
  });
});
